module.exports = __webpack_public_path__ + "img/team2.a3057a4b.jpg";